import { render, staticRenderFns } from "./recoveredMaterialList.vue?vue&type=template&id=ad16f722&scoped=true"
import script from "./recoveredMaterialList.vue?vue&type=script&lang=js"
export * from "./recoveredMaterialList.vue?vue&type=script&lang=js"
import style0 from "./recoveredMaterialList.vue?vue&type=style&index=0&id=ad16f722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad16f722",
  null
  
)

export default component.exports